import { useState, useEffect } from "react";
import pagos from "../../icons/pagosB.png";
import { useStoreLogin } from "../Login/useStoreLogin";
import { useStoreHome } from "../Home/useStoreHome";
import { MensajeError } from "../../componentes/FuncionesLocales";
import { useNavigate } from "react-router-dom";
import { formatearMoneda } from "../../config/moneda";
import "./pagos.css";

import { DataTable } from "primereact/datatable";
import { Column }    from "primereact/column";
import { Tag }       from "primereact/tag";
import { Button }    from "primereact/button";
import { Dialog }    from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Dropdown }  from "primereact/dropdown";
import { Checkbox }  from "primereact/checkbox";

// ─── MOCK (reemplazar con API real) ───────────────────────────────────────────
const MOCK_FACTURAS = [
  { Fecha: new Date("2026-09-02"), FormaPago: "Visa ****9972",       IdFactura: "G139382661", Monto: 897.23,  Estado: "Completado", EstadoPago: "Pago"      },
  { Fecha: new Date("2026-08-23"), FormaPago: "Transferencia",       IdFactura: "G130011237", Monto: 480.00,  Estado: "Pendiente",  EstadoPago: "Impago"    },
  { Fecha: new Date("2026-09-01"), FormaPago: "Visa ****9972",       IdFactura: "G133722546", Monto: 889.62,  Estado: "Completado", EstadoPago: "Pago"      },
  { Fecha: new Date("2026-08-15"), FormaPago: "Transferencia",       IdFactura: "G130011234", Monto: 450.00,  Estado: "Pendiente",  EstadoPago: "Impago"    },
  { Fecha: new Date("2026-08-01"), FormaPago: "Mastercard ****1234", IdFactura: "G128894512", Monto: 1200.00, Estado: "Completado", EstadoPago: "Pago"      },
  { Fecha: new Date("2026-07-01"), FormaPago: "Debito ****5678",     IdFactura: "G119874321", Monto: 760.50,  Estado: "Pendiente", EstadoPago: "Impago"    },
];

const MEDIOS_PAGO = [
  { label: "Tarjeta Credito",  value: "credito"       },
  { label: "Tarjeta Debito",   value: "debito"        },
  { label: "Transferencia",    value: "transferencia" },
];

const anioActual = new Date().getFullYear();
const MESES = Array.from({ length: 12 }, (_, i) => ({ label: String(i + 1).padStart(2, "0"), value: String(i + 1).padStart(2, "0") }));
const ANIOS = Array.from({ length: 10 }, (_, i) => ({ label: String(anioActual + i), value: String(anioActual + i) }));

// ─── HELPERS: solo facturas pendientes de pago ────────────────────────────────
const esPagable = (f) => f.EstadoPago !== "Pago";

// ─── TEMPLATES COLUMNAS ───────────────────────────────────────────────────────
const fechaTemplate     = (row) => row.Fecha.toLocaleDateString("es-AR");
const montoTemplate     = (row) => <span style={{ fontWeight: 600 }}>{formatearMoneda(row.Monto)}</span>;
const formaPagoTemplate = (row) => {
  const f = row.FormaPago.toLowerCase();
  let icon = "pi-wallet";
  if (f.includes("visa") || f.includes("mastercard") || f.includes("debito")) icon = "pi-credit-card";
  else if (f.includes("transfer")) icon = "pi-arrow-right-arrow-left";
  else if (f.includes("efectivo")) icon = "pi-money-bill";
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
      <i className={`pi ${icon}`} style={{ color: "#6e7172" }} />
      {row.FormaPago}
    </span>
  );
};
const idFacturaTemplate = (row) => (
  <span style={{ color: "var(--app-brand)", fontWeight: 600, cursor: "pointer", display: "inline-flex", alignItems: "center", gap: "4px" }}>
    {row.IdFactura} <i className="pi pi-download" style={{ fontSize: "0.75rem" }} />
  </span>
);
const estadoPagoTemplate = (row) => {
  const map = {
    Pago:      { severity: "success", label: "PAGO"      },
    Impago:    { severity: "danger",  label: "IMPAGO"    },
    
  };
  const cfg = map[row.EstadoPago] || map.Pendiente;
  return <Tag severity={cfg.severity} value={cfg.label} style={{ fontSize: "0.72rem", letterSpacing: "0.04em" }} />;
};

// ─── MODAL DE PAGO ─────────────────────────────────────────────────────────────
// Recibe `facturas` (array) — puede ser 1 o varias
function ModalPago({ visible, facturas, onClose }) {
  const [medio,          setMedio]          = useState("credito");
  const [titular,        setTitular]        = useState("");
  const [nroTarjeta,     setNroTarjeta]     = useState("");
  const [mes,            setMes]            = useState(null);
  const [anio,           setAnio]           = useState(null);
  const [cvv,            setCvv]            = useState("");
  const [email,          setEmail]          = useState("");
  const [aceptaTerminos, setAceptaTerminos] = useState(false);
  

  const totalAPagar = (facturas || []).reduce((acc, f) => acc + f.Monto, 0);
  const esMultiple  = (facturas || []).length > 1;

  const redTarjeta = (() => {
    const n = nroTarjeta.replace(/\s/g, "");
    if (n.startsWith("4")) return "VISA";
    if (n.startsWith("5")) return "MASTERCARD";
    if (n.startsWith("3")) return "AMEX";
    return null;
  })();

  const handleNroTarjeta = (e) => {
    const val = e.target.value.replace(/\D/g, "").slice(0, 16);
    setNroTarjeta(val.replace(/(.{4})/g, "$1 ").trim());
  };

  const handlePagar = () => {
    // TODO: integrar Mercado Pago
    // window.location.href = urlMercadoPago;
    alert("Redirigiendo a Mercado Pago... (pendiente de implementacion)");
  };

  const limpiarYCerrar = () => {
    setMedio("credito"); setTitular(""); setNroTarjeta("");
    setMes(null); setAnio(null); setCvv(""); setEmail("");
    
    onClose();
  };

  return (
    <Dialog
      visible={visible}
      onHide={limpiarYCerrar}
      header={null}
      closable={false}
      modal
      style={{ width: "min(95vw, 840px)", padding: 0 }}
      contentStyle={{ padding: 0 }}
      className="pagos-dialog"
    >
      <div className="pagos-modal-layout">

        {/* ── Izquierda: formulario ── */}
        <div className="pagos-modal-form">
          <div className="pagos-modal-header">
            <h3 style={{ margin: 0, fontSize: "1.1rem", fontWeight: 700, color: "#333" }}>Datos de pago</h3>
            <button onClick={limpiarYCerrar} className="pagos-modal-cerrar" title="Cerrar">
              <i className="pi pi-times" />
            </button>
          </div>

          <div className="pagos-modal-campo">
            <label className="pagos-modal-label">Medio de pago <span style={{ color: "red" }}>*</span></label>
            <Dropdown value={medio} options={MEDIOS_PAGO} onChange={(e) => setMedio(e.value)} style={{ width: "100%" }} />
          </div>

          <div className="pagos-modal-campo">
            <label className="pagos-modal-label">Titular de la tarjeta <span style={{ color: "red" }}>*</span></label>
            <InputText value={titular} onChange={(e) => setTitular(e.target.value)} placeholder="Responsable de pago" style={{ width: "100%" }} />
            <small className="pagos-modal-hint">Tal como esta impreso en la tarjeta.</small>
          </div>

          <div className="pagos-modal-campo">
            <label className="pagos-modal-label">Numero de tarjeta <span style={{ color: "red" }}>*</span></label>
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <InputText value={nroTarjeta} onChange={handleNroTarjeta} placeholder="0000 0000 0000 0000" maxLength={19} style={{ flex: 1 }} inputMode="numeric" />
              {redTarjeta && (
                <span className={`pagos-badge-red pagos-badge-${redTarjeta.toLowerCase()}`}>{redTarjeta}</span>
              )}
            </div>
            <small className="pagos-modal-hint">Numero de tarjeta, se recomienda un digito a la vez.</small>
          </div>

          <div className="pagos-modal-campo">
            <label className="pagos-modal-label">Vencimiento</label>
            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
              <div style={{ display: "flex", flexDirection: "column", flex: 1, minWidth: "80px" }}>
                <small style={{ marginBottom: "4px", color: "#555" }}>Mes</small>
                <Dropdown value={mes} options={MESES} onChange={(e) => setMes(e.value)} placeholder="MM" style={{ width: "100%" }} />
              </div>
              <div style={{ display: "flex", flexDirection: "column", flex: 1, minWidth: "100px" }}>
                <small style={{ marginBottom: "4px", color: "#555" }}>Año</small>
                <Dropdown value={anio} options={ANIOS} onChange={(e) => setAnio(e.value)} placeholder="AAAA" style={{ width: "100%" }} />
              </div>
              <div style={{ display: "flex", flexDirection: "column", flex: 1, minWidth: "90px" }}>
                <small style={{ marginBottom: "4px", color: "#555" }}>Cod. Seguridad</small>
                <InputText value={cvv} onChange={(e) => setCvv(e.target.value.replace(/\D/g, "").slice(0, 4))} placeholder="***" maxLength={4} inputMode="numeric" style={{ width: "100%" }} />
              </div>
            </div>
          </div>

          <div className="pagos-modal-campo">
            <label className="pagos-modal-label">Email <span style={{ color: "red" }}>*</span></label>
            <InputText value={email} onChange={(e) => setEmail(e.target.value)} placeholder="ejemplo@correo.com" type="email" style={{ width: "100%" }} />
          </div>
        </div>

        {/* ── Derecha: resumen ── */}
        <div className="pagos-modal-resumen">
          <h4 className="pagos-resumen-titulo">RESUMEN DE PAGO</h4>

          {/* Detalle de facturas — lista si son varias, simple si es una */}
          {esMultiple ? (
            <div className="pagos-resumen-lista">
              {(facturas || []).map((f) => (
                <div key={f.IdFactura} className="pagos-resumen-item">
                  <span className="pagos-resumen-item-id">{f.IdFactura}</span>
                  <span className="pagos-resumen-item-monto">{formatearMoneda(f.Monto)}</span>
                </div>
              ))}
            </div>
          ) : (
            <div className="pagos-resumen-linea">
              <span>{facturas?.[0] ? `Factura ${facturas[0].IdFactura}` : "Aranceles"}</span>
            </div>
          )}

          <hr className="pagos-resumen-hr" />

          <div className="pagos-resumen-total">
            <span style={{color: "#333"}}>Total a pagar{esMultiple ? ` (${facturas.length} facturas)` : ""}:</span>
            <span className="pagos-resumen-monto">{formatearMoneda(totalAPagar)}</span>
          </div>

          <div className="pagos-resumen-checks">
            <div className="pagos-check-fila">
              <Checkbox inputId="aceptaTerminos" checked={aceptaTerminos} onChange={(e) => setAceptaTerminos(e.checked)} />
              <label htmlFor="aceptaTerminos" style={{ fontSize: "0.83rem", cursor: "pointer",color: "#333" }}>
                Acepto los <span className="pagos-link-terminos">terminos y condiciones y politica de privacidad</span>.
              </label>
            </div>
            
          </div>

          <button className="pagos-btn-pagar" onClick={handlePagar} disabled={!aceptaTerminos}>
            Pagar
          </button>
          <button className="pagos-btn-cancelar" onClick={limpiarYCerrar}>
            Cancelar
          </button>
        </div>

      </div>
    </Dialog>
  );
}

// ─── COMPONENTE PRINCIPAL ──────────────────────────────────────────────────────
const Pagos = ({ modoVistaPrevia = false }) => {
  const FechaCaducidad = useStoreHome((state) => state.FechaCaducidad);
  const navigate = useNavigate();

  const [listaFacturas,  setListaFacturas]  = useState([]);
  const [cargando,       setCargando]       = useState(false);
  const [seleccionadas,  setSeleccionadas]  = useState([]);   // filas seleccionadas via checkbox
  const [modalVisible,   setModalVisible]   = useState(false);
  const [facturasModal,  setFacturasModal]  = useState([]);   // array que recibe el modal

  useEffect(() => {
    if (!modoVistaPrevia && !useStoreLogin.getState().validarVariablesGlobales()) useStoreLogin.getState().logout();
    const cargarTodas = async () => {
      setCargando(true);
      try {
        // TODO: reemplazar con axios.get("/api/pagos/facturas")
        await new Promise((resolve) => setTimeout(resolve, 400));
        setListaFacturas(MOCK_FACTURAS);
      } finally {
        setCargando(false);
      }
    };
    cargarTodas();
  }, [modoVistaPrevia]);

  useEffect(() => {
    if (FechaCaducidad && FechaCaducidad < new Date()) {
      MensajeError("La licencia de uso ha caducado. Contacte a soporte tecnico.");
      navigate("/home");
    }
  }, [FechaCaducidad, navigate]);

  // Abrir modal con una o varias facturas
  const abrirModal = (facturas) => {
    setFacturasModal(Array.isArray(facturas) ? facturas : [facturas]);
    setModalVisible(true);
  };

  // Al cerrar el modal limpiamos también la selección
  const cerrarModal = () => {
    setModalVisible(false);
    setSeleccionadas([]);
  };

  // Cambio de selección: solo permite tildar filas pagables
  const onSelectionChange = (e) => {
    const soloPageables = e.value.filter(esPagable);
    setSeleccionadas(soloPageables);
  };

  // Total seleccionado para mostrar en el botón
  const totalSeleccionado = seleccionadas.reduce((a, f) => a + f.Monto, 0);

  // Botón Pagar por fila — solo para facturas no pagadas
  const accionTemplate = (row) => {
    if (!esPagable(row)) return null;
    return (
      <Button
        label="Pagar"
        icon="pi pi-credit-card"
        size="small"
        onClick={() => abrirModal(row)}
        style={{ background: "#6e7172", border: "none", borderRadius: "8px", fontSize: "0.8rem", padding: "6px 12px" }}
      />
    );
  };

  // Row class: resaltar filas seleccionadas
  const rowClassName = (row) => ({
    "pagos-fila-seleccionada": seleccionadas.some((s) => s.IdFactura === row.IdFactura),
    "pagos-fila-pagada":       row.EstadoPago === "Pago",
  });

  return (
    <div className="pagos">

      {/* HEADER */}
      <div
        className="pag-header"
        style={{ backgroundColor: "#6e7172", padding: "12px 16px", borderRadius: "8px", color: "#fff", boxShadow: "0 2px 4px rgba(0,0,0,0.2)", display: "flex", alignItems: "center" }}
      >
        <img src={pagos} alt="pagos" className="ing-icono" />
        <div>
          <h2 className="ing-titulo" style={{ color: "#f4f4f4ff", textShadow: "0 2px 4px rgba(0,0,0,0.2)" }}>Pagos</h2>
          <p className="ing-parrafo" style={{ color: "#f4f4f4ff", textShadow: "0 2px 4px rgba(0,0,0,0.2)" }}>
            Realiza el pago de tus facturas desde esta pantalla, de forma rapida y segura
          </p>
        </div>
        <div className="btn-play" style={{ marginLeft: "auto" }}>
        </div>
      </div>

      {/* CONTENIDO */}
      <div className="ing-content-scroll">
        <div style={{ padding: "10px 0" }}>
          <div className="ing-registros">

            {/* ── Barra superior de la tabla ── */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "6px 5px 8px", gap: "10px", flexWrap: "wrap" }}>
              <h3 className="ing-subtitulo" style={{ margin: 0 }}>Historial de Facturas</h3>

              <div style={{ display: "flex", gap: "8px", alignItems: "center", flexWrap: "wrap" }}>

                {/* Botón "Pagar seleccionadas" — visible solo cuando hay selección */}
                {seleccionadas.length > 0 && (
                  <button
                    className="pagos-btn-pagar-multiple"
                    onClick={() => abrirModal(seleccionadas)}
                  >
                    <i className="pi pi-credit-card" style={{ marginRight: "6px" }} />
                    Pagar seleccionadas ({seleccionadas.length}) &nbsp;·&nbsp; {formatearMoneda(totalSeleccionado)}
                  </button>
                )}

                <Button
                  label="Exportar CSV"
                  icon="pi pi-download"
                  size="small"
                  outlined
                  style={{ borderRadius: "8px", color: "#6e7172", borderColor: "#6e7172", fontSize: "0.82rem" }}
                />
              </div>
            </div>

            <div className="ing-detalle">
              <DataTable
                value={listaFacturas}
                loading={cargando}
                paginator
                rows={10}
                rowsPerPageOptions={[5, 10, 25]}
                emptyMessage="No hay registros para mostrar"
                stripedRows
                style={{ fontSize: "0.88rem" }}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                // Seleccion multiple
                selection={seleccionadas}
                onSelectionChange={onSelectionChange}
                dataKey="IdFactura"
                rowClassName={rowClassName}
              >
                {/* Columna checkbox — isDataSelectable evita que se tilde una factura ya pagada */}
                <Column
                  selectionMode="multiple"
                  headerStyle={{ width: "3rem" }}
                  bodyStyle={{ textAlign: "center" }}
                  isDataSelectable={(e) => esPagable(e.data)}
                />

                <Column field="Fecha"      header="Fecha"          body={fechaTemplate}      sortable style={{ whiteSpace: "nowrap" }} />
                <Column field="FormaPago"  header="Forma de Pago"  body={formaPagoTemplate}  sortable style={{ whiteSpace: "nowrap" }} />
                <Column field="IdFactura"  header="ID de Factura"  body={idFacturaTemplate}           style={{ whiteSpace: "nowrap" }} />
                <Column field="Monto"      header="Monto"          body={montoTemplate}       sortable style={{ whiteSpace: "nowrap", textAlign: "center" }} />
                <Column field="Estado"     header="Estado"                                    sortable style={{ whiteSpace: "nowrap", textAlign: "center" }} />
                <Column field="EstadoPago" header="Estado de Pago" body={estadoPagoTemplate}  sortable style={{ textAlign: "center" }} />
                <Column header="Accion"    body={accionTemplate}                                       style={{ textAlign: "center", width: "110px" }} />
              </DataTable>
            </div>
          </div>
        </div>
      </div>

      {/* MODAL DE PAGO */}
      <ModalPago
        visible={modalVisible}
        facturas={facturasModal}
        onClose={cerrarModal}
      />

    </div>
  );
};

export default Pagos;
